import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "../../../Components/StateProvider";
import { useEffect, useState } from "react";
import {
  baseurl,
  ErrorAlert,
  GetDateTimeFormat,
  GetRecords,
  RupeeFormat,
  SuccessAlert,
  WarningAlert,
} from "../../../functions/api";
import axios from "axios";

const BillingReport = () => {
  const { companyId } = useParams();
  const store = useStore();
  const init = {
    fromDate: "",
    ToDate: "",
  };
  const initProps = {
    add: false,
    delete: false,
    on_off: false,
    print: false,
    update: false,
    view: false,
    fromDate: {},
    ToDate: {},
  };

  const [Record, setRecord] = useState(init);
  const [props, setprops] = useState(initProps);

  useEffect(() => {
    store.setmodule("billingreport", init);
    const dateTime = GetDateTimeFormat();
    handleMultiFieldChange({
      fromDate: dateTime.MonthStartDate + "Z",
      ToDate: dateTime.MonthEndDate + "Z",
    });
  }, []);

  useEffect(() => {
    console.log("Record State change -> ", Record);
    console.log("Props State change -> ", props);
    console.log("RupeeFormat change -> ", RupeeFormat(1500));
  }, [Record, props]);

  function Submit() {
    store.startLoading();
    let savedata = { ...Record };
    savedata.modifiedBy = store.getuser().id;
    savedata.createdBy = store.getuser().id;
    console.log("Submiting savedata", savedata);
    if (CheckMandatory()) {
      store.stopLoading();
      localStorage.setItem("journal_Number", Record.journal_Number + 1);
    }
  }
  function CheckMandatory() {
    let out = true;
    let Fields = "";
    for (let obj in props) {
      if (typeof props[obj] === "object") {
        if (props[obj].mandatory) {
          if (Record[obj] == "" || Record[obj] == " ") {
            HandlePropsChange(obj, { mandatory: true, show: true });
            out = false;
          } else {
            HandlePropsChange(obj, { mandatory: true, show: false });
          }
        }
      }
    }
    out === false && ErrorAlert("Please fill the Mandatory Fields.");
    out === false && store.stopLoading();
    return out;
  }
  function handleFieldChange(fieldName, value) {
    setRecord((prev) => {
      return { ...prev, [fieldName]: value };
    });
  }
  function handleMultiFieldChange(value = {}) {
    setRecord((prev) => {
      for (let fieldName in value) {
        prev[fieldName] = value[fieldName];
      }
      return { ...prev };
    });
  }
  function HandlePropsChange(fieldName, value = {}) {
    setprops((prev) => {
      let oldprop = prev[fieldName];

      for (let prophead in value) {
        oldprop[prophead] = value[prophead];
      }
      prev[fieldName] = oldprop;
      return { ...prev };
    });
  }

  const ExportExcel = (fromDates, ToDates) => {
    const startDate = fromDates || Record.fromDate;
    const endDate = ToDates || Record.ToDate;
    console.log("LOg_ExportExcel", startDate, " - - ", endDate);

    axios
      .get(
        `${baseurl}/api/v2/accounting/getBillingReport/${companyId}?startDate=${startDate}&endDate=${endDate}`,
        {
          responseType: "blob", // important!
        }
      )
      .then((response) => {
        // Create a Blob from the response
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a download link and click it
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        // Format the date using Intl.DateTimeFormat
        const formattedStartDate = new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "long",
        })
          .format(new Date(startDate))
          .replace(" ", "_"); // Replace space with colon as per your format "MMMM:yyyy"

        link.download = `BillingReport_${formattedStartDate}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        SuccessAlert("Billing Report Downloaded Successfully");
      })
      .catch((err) => {
        console.error("Download error:", err);
        WarningAlert("Something went wrong!");
      });
  };

  return (
    <>
      <div className="flex px-10 gap-3 py-1 bg-secondary justify-center items-center border-b border-Old_Silver">
        <div // fromDate
          className={
            "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
            (props.fromDate.hidden ? " hidden " : " flex ")
          }
        >
          <label className={"w-fit  min-w-[100px] max-w-full"}>
            From Date
            {props.fromDate.mandatory && (
              <span className="text-[#ff2828] text-[14px] h-fit">*</span>
            )}
          </label>
          <input
            className={
              "w-full border-b border-Old_Silver border-opacity-35 font-medium disabled:bg-[#c6c6ca]   text-black disabled:bg-opacity-20 px-2 py-1 " +
              (props.fromDate.mandatory && props.fromDate.show
                ? " rounded-2xl border-2 border-[#ff2828] "
                : "")
            }
            id={"fromDate"}
            type="date"
            value={Record.fromDate.split("T")[0]}
            disabled={props.fromDate.readonly}
            onChange={(event) => {
              console.log("fromDate new Tsate");
              const dateTime = GetDateTimeFormat(
                new Date(event.target.value + "T00:00:00Z")
              );
              console.log("fromDate new end date ");
              console.log(
                "fromDate new Start date ",
                dateTime.MonthEndDate + "Z"
              );

              handleMultiFieldChange({
                fromDate: event.target.value + "T00:00:00Z",
                ToDate: dateTime.MonthEndDate.split("T")[0] + "T00:00:00Z",
              });
            }}
          />
        </div>
        <div // ToDate
          className={
            "flex text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
            (props.ToDate.hidden ? " hidden " : " flex ")
          }
        >
          <label className={"w-fit  min-w-[100px] max-w-full"}>
            To Date
            {props.ToDate.mandatory && (
              <span className="text-[#ff2828] text-[14px] h-fit">*</span>
            )}
          </label>
          <input
            className={
              "w-full border-b border-Old_Silver border-opacity-35 font-medium disabled:bg-[#c6c6ca]   text-black disabled:bg-opacity-20 px-2 py-1 " +
              (props.ToDate.mandatory && props.ToDate.show
                ? " rounded-2xl border-2 border-[#ff2828] "
                : "")
            }
            id={"ToDate"}
            type="date"
            value={Record.ToDate.split("T")[0]}
            // disabled={props.ToDate.readonly}
            disabled={true}
            onChange={(event) => {
              if (
                new Date(Record.fromDate) <
                new Date(event.target.value + "T23:59:59Z")
              ) {
                handleFieldChange("ToDate", event.target.value + "T23:59:59Z");
                //loadRecord(Record.fromDate, event.target.value + "T23:59:59Z");
              } else {
                WarningAlert(
                  "The 'To Date' cannot be earlier than the 'From Date'"
                );
              }
            }}
          />
        </div>
        <div className="flex gap-5">
          <button
            className={
              "py-2 px-6 rounded-xl font-bold text-[12px]  bg-primary text-secondary"
            }
            onClick={() => ExportExcel(Record.fromDate, Record.ToDate)}
          >
            EXCEL
          </button>
        </div>
      </div>
      <div className="flex  h-[90%] px-6 pt-2 bg-secondary rounded-lg overflow-x-auto">
        <div className="w-full p-2">
          <p className="min-w-[400px] text-center ">
            Export Excel to view the billing report
          </p>
        </div>
      </div>
    </>
  );
};

export default BillingReport;
